import { ArrowUpRight, Package } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";
import { ICONS } from "../../data/defaults";

export const Services = () => {
  const { services } = useContent();
  return (
    <section id="services" className="bg-navy-50/60 py-24" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading eyebrow={services.eyebrow} title={services.title} desc={services.desc} />
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.items.map((s, i) => {
            const Icon = ICONS[s.icon] || Package;
            return (
              <Reveal key={s.title} delay={i * 0.07}>
                <a
                  href="/#quote"
                  data-testid={`service-card-${i}`}
                  className="group flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-navy/20 hover:shadow-xl hover:shadow-navy/10"
                >
                  <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-navy text-white transition-colors group-hover:bg-brandred">
                    <Icon size={26} />
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold text-navy">{s.title}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-sm font-bold text-brandred">
                    Get a quote
                    <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </a>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
